import { RequestState } from "./types";

export const getInitialState = <T>(
  initialState?: Partial<RequestState<T>>,
): RequestState<T> => ({
  isLoading: initialState?.isLoading ?? true,
  data: initialState?.data,
  error: initialState?.error,
});
